import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${colors.white};
    z-index: 999;
    top: 0px;
`;

export const Header = lib.styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px;
    font-weight: 700;
    color: ${colors.darkGray11};
`;

export const Button = lib.styled.div`
    cursor: pointer;
    color: ${colors.darkGray11};
`;

export const Body = lib.styled.div`
    display: flex;
    height: 91%;
    margin: 10px;
`;

// background-color: ${colors.white02};
export const RowItem = lib.styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${(props: { usage: string }) =>
      props.usage === 'sms' ? colors.white02 : '#fbefab'};
    border: 1px solid ${colors.lightGray17};
    border-radius: 10px;
    padding: 5px;
    height: 40px;
    margin-bottom: 7px;
    cursor: pointer;
    font-size: 12px;
    
    span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #3D505A80;
    }   

    span:first-of-type {
        font-weight: 700;
        font-size: 14px;
        color: ${colors.darkGray11};
    }
`;

export const Loader = lib.styled.div`
    display: flex;
    margin-left: -10px;
    align-items: center;
    justify-content: center;
`;
